import React, { Fragment } from 'react';
import KycDisplay from './KycDisplay';
import useFieldRevealTracker from '../hooks/useFieldRevealTracker';

export default function OwnersConfirmation({
  onRevealSuccess,
  onRevealFail,
  token,
  owners,
}: {
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
  owners: Owner[];
}) {
  const kycs = [];
  for (const owner of owners) {
    if (owner.kyc) {
      kycs.push(owner.kyc);
    }
  }
  const onFieldRevealSuccess = useFieldRevealTracker(
    onRevealSuccess,
    kycs.map((_, index) => `owner_${index}`),
  );
  if (!kycs.length) {
    return null;
  }
  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-full my-2'>
          <p className='confirmation-page-heading'>Owners</p>
        </div>
      </div>
      {kycs.map((kyc, index) => (
        <KycDisplay
          kyc={kyc}
          onRevealSuccess={onFieldRevealSuccess(`owner_${index}`)}
          onRevealFail={onRevealFail}
          token={token}
          key={index}
        />
      ))}
    </Fragment>
  );
}
